import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PagedAiPresetsResponse,
  ApiResponse,
  PresetResponse,
  UpdatePresetCategoryRequest,
} from '../models/ai-presets.models';
import { AiPresetsApiService } from './ai-presets-api.service';

@Injectable({
  providedIn: 'root',
})
export class AiPresetsService {
  private readonly apiService = inject(AiPresetsApiService);

  getPresets(offset: number = 0, limit: number = 20): Observable<PagedAiPresetsResponse> {
    return this.apiService.getPresets(offset, limit);
  }

  deletePreset(perfectlyClearPresetId: string): Observable<{ success: boolean; message: string; data?: string }> {
    return this.apiService.deletePreset(perfectlyClearPresetId);
  }

  uploadPreset(name: string, description: string, file: File, categoryId?: number): Observable<{ success: boolean; message?: string }> {
    return this.apiService.uploadPreset(name, description, file, categoryId);
  }

  updatePresetCategory(
    presetId: number,
    request: UpdatePresetCategoryRequest
  ): Observable<ApiResponse<PresetResponse>> {
    return this.apiService.updatePresetCategory(presetId, request);
  }
}
